import useCreditData from './useCreditData';

export default function useCreditProgramPayment(carId?: string) {
  const creditData = useCreditData(carId);
  return creditData?.choice?.program?.payment;
}
